import React from 'react';
import WebLayout from '../layouts/WebLayout';
import Terms from '../../../common/Terms';

const TermsPage = () => {
    return (
        <WebLayout>
            <div className="min-h-screen">
                {/* 이용약관 페이지 본문 내용이 여기에 들어갑니다 */}
                <Terms />
            </div>
        </WebLayout>
    );
};

export default TermsPage;
